import React from 'react';

import { useTranslation } from 'react-i18next';

interface ExtensionDetectedSuccessProps {
  onReconfigure?: () => void;
  showReconfigure?: boolean;
}

export const ExtensionDetectedSuccess: React.FC<
  ExtensionDetectedSuccessProps
> = ({ onReconfigure, showReconfigure = false }) => {
  const { t } = useTranslation('pleri/onboarding');

  return (
    <div className="mx-auto max-w-2xl text-center">
      <div className="mb-12 flex items-center justify-center">
        <h2 className="text-2xl leading-tight font-semibold text-gray-900 dark:text-gray-100">
          {t('browserExtensionDetected')}
        </h2>
      </div>
      <div className="relative mx-auto mb-12 inline-block">
        <div className="absolute inset-0 animate-[pulse_4s_ease-in-out_infinite] rounded-full bg-green-50 blur-xl dark:bg-green-950/10" />
        <div className="relative flex h-24 w-24 items-center justify-center rounded-full bg-gradient-to-br from-green-500/20 to-green-600/20">
          <svg
            className="h-12 w-12 text-green-500"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M5 13l4 4L19 7"
            />
          </svg>
        </div>
      </div>
      <div className="mx-auto mb-12 max-w-md rounded-lg bg-gradient-to-br from-green-500/5 to-green-600/5 p-6">
        <h3 className="mb-4 text-lg font-semibold text-gray-900 dark:text-gray-100">
          {t('browserExtensionInstalledHeading')}
        </h3>
        <p className="text-gray-700 dark:text-gray-300">
          {t('greatWeHaveDetectedThatYouHave')}
        </p>
      </div>
      <div className="flex flex-col gap-4">
        {showReconfigure && onReconfigure && (
          <button
            onClick={onReconfigure}
            className="text-sm text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-300"
          >
            {t('reconfigureExtension')}
          </button>
        )}
      </div>
    </div>
  );
};
